import React from 'react';
import Combobox from './primitives/Combobox';
import Departments, { Department } from '../../../views/Departments';
import { useDepartments } from '../../hooks/masterdata/useDepartments';
import { t } from '../l10n/l10n';

export interface DepartmentComboboxProps {
    disableCreate?: boolean;
    hideInlineSearch: boolean;
    omitDistributionKeys: boolean;
    hideBarred: boolean;
    includeNoDepartmentOption?: boolean;
    onCreated?: Function;
    [x: string]: any;
    hideSummary?: boolean;
    modalDraggable?: boolean;
}

/**
 * @deprecated Use {@link DimensionLineCombobox} instead.
 */
export default function DepartmentCombobox({
    disableCreate = false,
    hideInlineSearch,
    omitDistributionKeys = false,
    hideBarred,
    onCreated,
    hideSummary = false,
    includeNoDepartmentOption = false,
    ...props
}: DepartmentComboboxProps) {
    const { data: departments } = useDepartments({
        hideBarred,
        omitDistributionKeys,
        includeNoDepartmentOption,
        options: { useCache: props?.useCache },
    });

    return (
        <Combobox<Department>
            {...props}
            aria-label={props['aria-label'] ?? t`LEFTMENU_SETTINGS_DEPARTMENTS`}
            data={departments?.map(department => ({
                data: department,
                text: hideInlineSearch ? '' : `${department.number} - ${department.name}`,
                summary: hideSummary ? undefined : department.name,
                value: department.number,
            }))}
            modal={({ hide, onChange }) => (
                <Departments
                    disableCreate={disableCreate}
                    modalDraggable={props.modalDraggable}
                    omitDistributionKeys={omitDistributionKeys}
                    showSaveAndApply
                    onCreated={department => {
                        onCreated?.(department);
                        onChange(department.number, department, true);
                        hide();
                    }}
                    onSelected={department => {
                        onChange(department.number, department);
                        hide();
                    }}
                    hideBarred={hideBarred}
                    includeNoDepartmentOption={includeNoDepartmentOption}
                />
            )}
            modalSize="sm"
            style={{ width: '120px' }}
        />
    );
}
